import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { SandboxConnectionWizard } from '../components/connection';
import { SupportBanner } from '../components/ui';
import { getRequestAsync } from '../../../helpers/apiHandler';
import { showAlert } from '../../../store/actions/alertAction';

const WhatsAppSandbox = () => {
    const { access_token } = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [sandboxData, setSandboxData] = useState(null);

    useEffect(() => {
        fetchSandboxStatus();
    }, [access_token]);

    const fetchSandboxStatus = async () => {
        try {
            setIsLoading(true);
            const response = await getRequestAsync(
                '/v2/whatsapp/sandbox-status',
                { headers: { Authorization: access_token.token } }
            );

            if (response && !response.error) {
                setSandboxData(response.data);
            } else {
                dispatch(showAlert('Failed to fetch sandbox status', 'danger'));
            }
        } catch (error) {
            console.error('Error fetching sandbox status:', error);
            dispatch(showAlert('An error occurred while fetching sandbox status', 'danger'));
        } finally {
            setIsLoading(false);
        }
    };

    const renderContent = () => {
        if (isLoading) {
            return (
                <div className="loading-state text-center my-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">Loading sandbox information...</p>
                </div>
            );
        }

        if (!sandboxData?.sandbox_active) {
            return (
                <div className="sandbox-inactive-container text-center my-5">
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-5">
                            <h3 className="mb-4">Sandbox Not Activated</h3>
                            <p className="text-muted mb-4">
                                You need to activate the WhatsApp sandbox to access this feature.
                                Please go to the WhatsApp dashboard and click on "Sandbox" to activate.
                            </p>
                            <Button
                                onClick={() => window.history.back()}
                                variant="outline-primary"
                            >
                                Return to Dashboard
                            </Button>
                        </Card.Body>
                    </Card>
                </div>
            );
        }

        return (
            <SandboxConnectionWizard
                phoneNumber={sandboxData.test_phone_number || ''}
                accessCode={sandboxData.secret_access_code || ''}
            />
        );
    };

    return (
        <div className="whatsapp-sandbox-page">
            <Container fluid className="p-4">
                <Row>
                    <Col lg={8}>
                        <div className="whatsapp-sandbox-card mb-4">
                            <div className="whatsapp-sandbox-card-body">
                                <h1 className="whatsapp-sandbox-title">WhatsApp Sandbox</h1>
                                <p className="whatsapp-sandbox-description">
                                    elfoA2P Sandbox for WhatsApp allows you to test your app in a developer environment without WhatsApp approval for your account.
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        {renderContent()}
                    </Col>
                </Row>
            </Container>
            <SupportBanner />
        </div>
    );
};

export default WhatsAppSandbox;